var module = angular.module('octopusApp.projects');

module.controller('ChannelDesignRuleController', function ($scope,$uibModalInstance, octopusRepository, rule, samplePackages) {
  $scope.rule = {
    versionRange: rule.versionRange,
    tag: rule.tag
  };
  $scope.warnings = [];
  $scope.close = $uibModalInstance.close;
  $scope.save = save;
  $scope.testVersion = testVersion;
  $scope.samplePackages = samplePackages;

  function save() {
    $uibModalInstance.close($scope.rule);
  }

  function testVersion(version, done){
    octopusRepository.Channels.ruleTest(version, { versionRange: $scope.rule.versionRange, preReleaseTag: $scope.rule.tag}).then(function(result){
      showErrors(result);
      done(version, result);
    });
  }

  function showErrors(result) {
    $scope.rangeClass = result.Errors.indexOf("Invalid Version Range") === -1 ? "" : "warning";
    $scope.tagClass = result.Errors.indexOf("Invalid Pre-Release Tag") === -1 ? "" : "warning";

    $scope.warnings = [];
    $scope.error = null;

    if($scope.rangeClass) {
      $scope.warnings.push("The version range does not appear to be a valid NuGet version range.");
    }
    if($scope.tagClass) {
      $scope.warnings.push("The pre-release tag appears to be an invalid .net regex patterm.");
    }
  }
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/channels/design_rule_controller.js
// module id = 510
// module chunks = 1